import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { ApartmentOutlined } from '@ant-design/icons';
import RibbonButton from 'common/components/button/RibbonButton';

import { useGetProductFullView } from 'hooks';
import { useSsoProductParams } from 'hooks/useSso';
import Messages from 'i18n/messages/home';
import useToggleActiveRibbon from './hook';

const ProductHierarchy = ({ productId }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const { productFull } = useGetProductFullView({ productId });

  const { ssoParamUrl: ssoProductParams, productId: ssoProductId } =
    useSsoProductParams();

  const checkActiveContent = () => {
    const path = location?.pathname;

    const regex = /\/product\/hierarchy\/\d+$/;
    return regex.test(path);
  };

  const isPathActive = checkActiveContent();
  const isActive = useToggleActiveRibbon(isPathActive);

  const handleClick = () => {
    if (isActive) {
      if (ssoProductParams) {
        navigate(`/product/${ssoProductId}/?${ssoProductParams}`);
      } else {
        navigate(`/product/${productFull?.productId}`);
      }
    } else {
      if (ssoProductParams) {
        navigate(`/product/hierarchy/${ssoProductId}?${ssoProductParams}`);
      } else {
        navigate(`/product/hierarchy/${productFull?.productId}`);
      }
    }
  };

  return (
    <RibbonButton
      icon={<ApartmentOutlined style={{ height: 26 }} />}
      label={Messages.productHierarchy}
      onClick={handleClick}
      toggle={isPathActive}
      disabled={!productFull?.productId}
    />
  );
};

export default ProductHierarchy;
